// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.player-container {
	container-type: inline-size;
	container-name: player-container;
}

.playback-bar {
	position: absolute;
	bottom: 0px;
	width: var(--playback-bar-width);
	min-height: var(--playback-bar-height);
	left: calc((100% - var(--playback-bar-width)) / 2);
	right: calc((100% - var(--playback-bar-width)) / 2);
	background: var(--secondary-bg-color);
	background: var(--main-bg-gradient);
	z-index: 100;
	container-type: inline-size;
	container-name: playback-bar;
}

.playback-bar.inline-mode {
	display: flex;
	align-items: center;
  	user-select: none;
}

.playback-bar:hover {
	background: var(--secondary-bg-color-hover);
}

.progress-indicator {
	width: 98%;
	margin-left: 1%;
	height: var(--progress-indicator-height);
}

.progress-indicator.inline-mode {
	flex: 1;
}

.progress-indicator-timer {
	position: absolute;
	top:1px;
	color: var(--main-fg-color);
	font-size: 10px;
	line-height: 11px;
	padding-left: 11px;
	pointer-events: none;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 1;
}

.progress-indicator-timer.left-side {
	left: 0px;
}

.progress-indicator-timer.right-side {
	right: 0px;
}

.playback-bar .button-plugins {
	height: var(--button-fixed-height);
}

.playback-bar .button-plugins.left-side {
	float: left;
}

.playback-bar .button-plugins.right-side {
	float: right;
}

.playback-bar .button-plugins .button-plugin-container {
	display: inline;
}

.playback-bar .button-plugins .button-plugin-container button {
	height: var(--button-fixed-height);
	background: none;
	border: none;
	float: left;
	align-items: center;
	align-items: center;
    justify-content: center;
}

.playback-bar .button-plugins .button-plugin-container button.dynamic-width div.interactive-button-content {
	display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: row;
}

.playback-bar .button-plugins .button-plugin-container button.fixed-width {
	width: var(--button-fixed-width);
}

.playback-bar .button-plugins button:hover {
	background-color: var(--highlight-bg-color-hover);
}

.playback-bar .button-plugins button:active {
	background-color: var(--secondary-bg-color-hover);
}

.playback-bar .button-plugins button.dynamic-width span {
	margin-top: 0px;
	color: var(--main-fg-color);
	padding-left: 3px;
	padding-right: 3px;
}

.playback-bar .button-plugins button i {
	background-size: 50% 50%;
	width: var(--button-icon-size);
	display: block;
	background-repeat: no-repeat;
	background-position: 3px 7px;
	margin-left: auto;
	margin-right: auto;
}

/* non-interactive buttons **/
.playback-bar .button-plugins .button-plugin-container div.non-interactive {
	height: var(--button-fixed-height);
	background: none;
	border: none;
	float: left;
	box-sizing: border-box;
	display: flex;
    align-items: center;
    justify-content: center;
	pointer-events: none;
}

.playback-bar .button-plugins .button-plugin-container div.dynamic-width div.non-interactive-button-content {
	display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: row;
}

.playback-bar .button-plugins .button-plugin-container div.non-interactive.fixed-width {
	width: var(--button-fixed-width);
}

.playback-bar .button-plugins div.non-interactive i {
	background-size: 50% 50%;
	width: var(--button-icon-size);
	display: block;
	background-repeat: no-repeat;
	background-position: 3px 7px;
	margin-left: auto;
	margin-right: auto;
}

.playback-bar .button-plugins div.non-interactive span {
	display: block;
	text-align: center;
	margin-top: -23px;
}

.playback-bar .button-plugins div.no-icon span {
	line-height: var(--button-fixed-height);
    margin-top: 0px;
	color: var(--main-fg-color);
}

.playback-bar .button-plugins div.dynamic-width span {
	margin-top: 0px;
	color: var(--main-fg-color);
	padding-left: 3px;
	padding-right: 3px;
}

.playback-bar .button-plugins .button-plugin-container div.non-interactive {
	padding: 2px 6px 3px 6px;
}
.video-container .button-plugins .button-plugin-container div.non-interactive {
	padding: 2px 6px 3px 6px;
}

.playback-bar .button-plugins div.non-interactive i svg {
	width: 100%;
    height: 100%;
    fill: var(--main-fg-color);
	color: var(--main-fg-color);
}


/* Fix default iPad button padding */
.playback-bar .button-plugins .button-plugin-container button {
	padding: 0px 6px 0px 6px;
}
.video-container .button-plugins .button-plugin-container button {
	padding: 0px 6px 0px 6px;
}

.button-plugins span.button-title {
    display: block;
}

.button-plugins span.button-title.button-title-small {
	margin-top: -13px;
    font-size: 8px;
}

.button-plugins span.button-title.button-title-medium {
	margin-top: -14px;
    font-size: 10px;
}

.button-plugins span.button-title.button-title-large {
	margin-top: -16px;
    font-size: 12px;
}

.button-plugins span.button-title:empty {
	margin-top: 0 !important;
}


.playback-bar .button-plugins button i svg {
	width: 100%;
    height: 100%;
    fill: var(--main-fg-color);
	color: var(--main-fg-color);
}

.playback-bar .button-plugin-side-area {
	display: inline;
	color: var(--main-fg-color);
	height: 40px;
	line-height: 40px;
}

.playback-bar .timer-container {
	height: 40px;
	line-height: 40px;
	display: none;
}

.playback-bar .timer-container.left-side {
	float: left;
	display: block;
}

.playback-bar .timer-container.right-side {
	float: right;
	display: block;
}

.progress-indicator {
	position: relative;
}

.progress-indicator canvas {
	position: absolute;
	left: 0px;
	top: 0px;
	pointer-events: none;
	opacity: 0.5;
}

.playback-bar:hover .progress-indicator canvas {
	opacity: 1;
}

.progress-indicator .progress-indicator-container {
	position: absolute;
	left: 0px;
	top: 0px;
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
}

.progress-indicator-container .progress-indicator-content {
	height: 10px;
	background-color: var(--highlight-bg-color-hover);
	opacity: 0.8;
	pointer-events: none;
}

.playback-bar:hover .progress-indicator-container .progress-indicator-content {
	background-color: var(--highlight-bg-color-hover);
}

.progress-indicator-remaining {
	display: block;
	width: 100%;
	background-color: rgb(139, 139, 139);
	height: 10px;
	position: absolute;
	z-index: -1;
	opacity: 0.4;
}

.progress-indicator-handler {
	display: block;
	width: var(--progress-indicator-handler-size);
	height: var(--progress-indicator-handler-size);
	margin-left: -10px;
	background-color: var(--highlight-bg-color-hover);
	border-radius: 10px;
	z-index: 1;
}

.frame-thumbnail {
	background-color: var(--secondary-bg-color-hover);
	min-width: 100px;
	min-height: 100px;
	box-shadow: 0px 0px 5px 0px var(--main-bg-color);
	z-index: 10000;
	pointer-events: none;
}

.frame-thumbnail .thumbnail-image {
	pointer-events: none;
}

.timer-container .progress-indicator-timer {
	position: static;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
}


@media (max-width: 500px) {
	.frame-thumbnail .thumbnail-image {
		width: 130px;
		pointer-events: none;
	}
}

@media (max-width: 750px) {
	.frame-thumbnail .thumbnail-image {
		width: 230px;
		pointer-events: none;
	}
}

@media (min-width: 750px) {
	.frame-thumbnail .thumbnail-image {
		width: 330px;
		pointer-events: none;
	}
}

.frame-thumbnail .thumbnail-time {
	pointer-events: none;
	font-size: 12px;
	line-height: 12px;
	display: block;
	height: 12px;
	color: var(--main-fg-color);
	text-align: center;
	margin: 0;
	padding: 1;
}

@container player-container (max-width: 700px) {
	.playback-bar {
		min-height: var(--playback-bar-height-sm);
	}
}

@container playback-bar (max-width: 700px) {

	.playback-bar .button-plugins button i {
		width: var(--button-icon-size-sm);
	}

	.playback-bar .button-plugins {
		height: var(--button-fixed-height-sm);
	}

	.playback-bar .button-plugins .button-plugin-container button {
		height: var(--button-fixed-height-sm);
	}

	.playback-bar .button-plugins .button-plugin-container button.fixed-width {
		width: var(--button-fixed-width-sm);
	}

	.playback-bar .button-plugins .button-plugin-container div.non-interactive {
		height: var(--button-fixed-height-sm);
	}

	.playback-bar .button-plugins .button-plugin-container div.non-interactive.fixed-width {
		width: var(--button-fixed-width-sm);
	}

	.playback-bar .button-plugins div.non-interactive i {
		width: var(--button-icon-size-sm);
	}

	.playback-bar .button-plugins div.no-icon span {
		line-height: var(--button-fixed-height-sm);
	}
}`, "",{"version":3,"sources":["webpack://./src/css/PlaybackBar.css"],"names":[],"mappings":";AACA;CACC,2BAA2B;CAC3B,gCAAgC;AACjC;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,gCAAgC;CAChC,sCAAsC;CACtC,kDAAkD;CAClD,mDAAmD;CACnD,qCAAqC;CACrC,mCAAmC;CACnC,YAAY;CACZ,2BAA2B;CAC3B,4BAA4B;AAC7B;;AAEA;CACC,aAAa;CACb,mBAAmB;GACjB,iBAAiB;AACpB;;AAEA;CACC,2CAA2C;AAC5C;;AAEA;CACC,UAAU;CACV,eAAe;CACf,wCAAwC;AACzC;;AAEA;CACC,OAAO;AACR;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,2BAA2B;CAC3B,eAAe;CACf,iBAAiB;CACjB,kBAAkB;CAClB,oBAAoB;CACpB,YAAY;CACZ,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,UAAU;AACX;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,kCAAkC;CAClC,gBAAgB;CAChB,YAAY;CACZ,WAAW;CACX,mBAAmB;CACnB,mBAAmB;IAChB,uBAAuB;AAC3B;;AAEA;CACC,aAAa;IACV,2BAA2B;IAC3B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,iDAAiD;AAClD;;AAEA;CACC,iDAAiD;AAClD;;AAEA;CACC,eAAe;CACf,2BAA2B;CAC3B,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,wBAAwB;CACxB,8BAA8B;CAC9B,cAAc;CACd,4BAA4B;CAC5B,4BAA4B;CAC5B,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA,6BAA6B;AAC7B;CACC,kCAAkC;CAClC,gBAAgB;CAChB,YAAY;CACZ,WAAW;CACX,sBAAsB;CACtB,aAAa;IACV,mBAAmB;IACnB,uBAAuB;CAC1B,oBAAoB;AACrB;;AAEA;CACC,aAAa;IACV,2BAA2B;IAC3B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,wBAAwB;CACxB,8BAA8B;CAC9B,cAAc;CACd,4BAA4B;CAC5B,4BAA4B;CAC5B,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,uCAAuC;IACpC,eAAe;CAClB,2BAA2B;AAC5B;;AAEA;CACC,eAAe;CACf,2BAA2B;CAC3B,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,wBAAwB;AACzB;AACA;CACC,wBAAwB;AACzB;;AAEA;CACC,WAAW;IACR,YAAY;IACZ,0BAA0B;CAC7B,2BAA2B;AAC5B;;;AAGA,oCAAoC;AACpC;CACC,wBAAwB;AACzB;AACA;CACC,wBAAwB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;CACC,iBAAiB;IACd,cAAc;AAClB;;AAEA;CACC,iBAAiB;IACd,eAAe;AACnB;;AAEA;CACC,iBAAiB;IACd,eAAe;AACnB;;AAEA;CACC,wBAAwB;AACzB;;;AAGA;CACC,WAAW;IACR,YAAY;IACZ,0BAA0B;CAC7B,2BAA2B;AAC5B;;AAEA;CACC,eAAe;CACf,2BAA2B;CAC3B,YAAY;CACZ,iBAAiB;AAClB;;AAEA;CACC,YAAY;CACZ,iBAAiB;CACjB,aAAa;AACd;;AAEA;CACC,WAAW;CACX,cAAc;AACf;;AAEA;CACC,YAAY;CACZ,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,QAAQ;CACR,oBAAoB;CACpB,YAAY;AACb;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,QAAQ;CACR,WAAW;CACX,YAAY;CACZ,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,YAAY;CACZ,iDAAiD;CACjD,YAAY;CACZ,oBAAoB;AACrB;;AAEA;CACC,iDAAiD;AAClD;;AAEA;CACC,cAAc;CACd,WAAW;CACX,oCAAoC;CACpC,YAAY;CACZ,kBAAkB;CAClB,WAAW;CACX,YAAY;AACb;;AAEA;CACC,cAAc;CACd,6CAA6C;CAC7C,8CAA8C;CAC9C,kBAAkB;CAClB,iDAAiD;CACjD,mBAAmB;CACnB,UAAU;AACX;;AAEA;CACC,iDAAiD;CACjD,gBAAgB;CAChB,iBAAiB;CACjB,gDAAgD;CAChD,cAAc;CACd,oBAAoB;AACrB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,gBAAgB;CAChB,YAAY;CACZ,aAAa;CACb,uBAAuB;CACvB,mBAAmB;AACpB;;;AAGA;CACC;EACC,YAAY;EACZ,oBAAoB;CACrB;AACD;;AAEA;CACC;EACC,YAAY;EACZ,oBAAoB;CACrB;AACD;;AAEA;CACC;EACC,YAAY;EACZ,oBAAoB;CACrB;AACD;;AAEA;CACC,oBAAoB;CACpB,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,YAAY;CACZ,2BAA2B;CAC3B,kBAAkB;CAClB,SAAS;CACT,UAAU;AACX;;AAEA;CACC;EACC,yCAAyC;CAC1C;AACD;;AAEA;;CAEC;EACC,iCAAiC;CAClC;;CAEA;EACC,qCAAqC;CACtC;;CAEA;EACC,qCAAqC;CACtC;;CAEA;EACC,mCAAmC;CACpC;;CAEA;EACC,qCAAqC;CACtC;;CAEA;EACC,mCAAmC;CACpC;;CAEA;EACC,iCAAiC;CAClC;;CAEA;EACC,0CAA0C;CAC3C;AACD","sourcesContent":["\n.player-container {\n\tcontainer-type: inline-size;\n\tcontainer-name: player-container;\n}\n\n.playback-bar {\n\tposition: absolute;\n\tbottom: 0px;\n\twidth: var(--playback-bar-width);\n\tmin-height: var(--playback-bar-height);\n\tleft: calc((100% - var(--playback-bar-width)) / 2);\n\tright: calc((100% - var(--playback-bar-width)) / 2);\n\tbackground: var(--secondary-bg-color);\n\tbackground: var(--main-bg-gradient);\n\tz-index: 100;\n\tcontainer-type: inline-size;\n\tcontainer-name: playback-bar;\n}\n\n.playback-bar.inline-mode {\n\tdisplay: flex;\n\talign-items: center;\n  \tuser-select: none;\n}\n\n.playback-bar:hover {\n\tbackground: var(--secondary-bg-color-hover);\n}\n\n.progress-indicator {\n\twidth: 98%;\n\tmargin-left: 1%;\n\theight: var(--progress-indicator-height);\n}\n\n.progress-indicator.inline-mode {\n\tflex: 1;\n}\n\n.progress-indicator-timer {\n\tposition: absolute;\n\ttop:1px;\n\tcolor: var(--main-fg-color);\n\tfont-size: 10px;\n\tline-height: 11px;\n\tpadding-left: 11px;\n\tpointer-events: none;\n\theight: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tz-index: 1;\n}\n\n.progress-indicator-timer.left-side {\n\tleft: 0px;\n}\n\n.progress-indicator-timer.right-side {\n\tright: 0px;\n}\n\n.playback-bar .button-plugins {\n\theight: var(--button-fixed-height);\n}\n\n.playback-bar .button-plugins.left-side {\n\tfloat: left;\n}\n\n.playback-bar .button-plugins.right-side {\n\tfloat: right;\n}\n\n.playback-bar .button-plugins .button-plugin-container {\n\tdisplay: inline;\n}\n\n.playback-bar .button-plugins .button-plugin-container button {\n\theight: var(--button-fixed-height);\n\tbackground: none;\n\tborder: none;\n\tfloat: left;\n\talign-items: center;\n\talign-items: center;\n    justify-content: center;\n}\n\n.playback-bar .button-plugins .button-plugin-container button.dynamic-width div.interactive-button-content {\n\tdisplay: flex;\n    justify-content: flex-start;\n    align-items: center;\n    flex-direction: row;\n}\n\n.playback-bar .button-plugins .button-plugin-container button.fixed-width {\n\twidth: var(--button-fixed-width);\n}\n\n.playback-bar .button-plugins button:hover {\n\tbackground-color: var(--highlight-bg-color-hover);\n}\n\n.playback-bar .button-plugins button:active {\n\tbackground-color: var(--secondary-bg-color-hover);\n}\n\n.playback-bar .button-plugins button.dynamic-width span {\n\tmargin-top: 0px;\n\tcolor: var(--main-fg-color);\n\tpadding-left: 3px;\n\tpadding-right: 3px;\n}\n\n.playback-bar .button-plugins button i {\n\tbackground-size: 50% 50%;\n\twidth: var(--button-icon-size);\n\tdisplay: block;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 3px 7px;\n\tmargin-left: auto;\n\tmargin-right: auto;\n}\n\n/* non-interactive buttons **/\n.playback-bar .button-plugins .button-plugin-container div.non-interactive {\n\theight: var(--button-fixed-height);\n\tbackground: none;\n\tborder: none;\n\tfloat: left;\n\tbox-sizing: border-box;\n\tdisplay: flex;\n    align-items: center;\n    justify-content: center;\n\tpointer-events: none;\n}\n\n.playback-bar .button-plugins .button-plugin-container div.dynamic-width div.non-interactive-button-content {\n\tdisplay: flex;\n    justify-content: flex-start;\n    align-items: center;\n    flex-direction: row;\n}\n\n.playback-bar .button-plugins .button-plugin-container div.non-interactive.fixed-width {\n\twidth: var(--button-fixed-width);\n}\n\n.playback-bar .button-plugins div.non-interactive i {\n\tbackground-size: 50% 50%;\n\twidth: var(--button-icon-size);\n\tdisplay: block;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 3px 7px;\n\tmargin-left: auto;\n\tmargin-right: auto;\n}\n\n.playback-bar .button-plugins div.non-interactive span {\n\tdisplay: block;\n\ttext-align: center;\n\tmargin-top: -23px;\n}\n\n.playback-bar .button-plugins div.no-icon span {\n\tline-height: var(--button-fixed-height);\n    margin-top: 0px;\n\tcolor: var(--main-fg-color);\n}\n\n.playback-bar .button-plugins div.dynamic-width span {\n\tmargin-top: 0px;\n\tcolor: var(--main-fg-color);\n\tpadding-left: 3px;\n\tpadding-right: 3px;\n}\n\n.playback-bar .button-plugins .button-plugin-container div.non-interactive {\n\tpadding: 2px 6px 3px 6px;\n}\n.video-container .button-plugins .button-plugin-container div.non-interactive {\n\tpadding: 2px 6px 3px 6px;\n}\n\n.playback-bar .button-plugins div.non-interactive i svg {\n\twidth: 100%;\n    height: 100%;\n    fill: var(--main-fg-color);\n\tcolor: var(--main-fg-color);\n}\n\n\n/* Fix default iPad button padding */\n.playback-bar .button-plugins .button-plugin-container button {\n\tpadding: 0px 6px 0px 6px;\n}\n.video-container .button-plugins .button-plugin-container button {\n\tpadding: 0px 6px 0px 6px;\n}\n\n.button-plugins span.button-title {\n    display: block;\n}\n\n.button-plugins span.button-title.button-title-small {\n\tmargin-top: -13px;\n    font-size: 8px;\n}\n\n.button-plugins span.button-title.button-title-medium {\n\tmargin-top: -14px;\n    font-size: 10px;\n}\n\n.button-plugins span.button-title.button-title-large {\n\tmargin-top: -16px;\n    font-size: 12px;\n}\n\n.button-plugins span.button-title:empty {\n\tmargin-top: 0 !important;\n}\n\n\n.playback-bar .button-plugins button i svg {\n\twidth: 100%;\n    height: 100%;\n    fill: var(--main-fg-color);\n\tcolor: var(--main-fg-color);\n}\n\n.playback-bar .button-plugin-side-area {\n\tdisplay: inline;\n\tcolor: var(--main-fg-color);\n\theight: 40px;\n\tline-height: 40px;\n}\n\n.playback-bar .timer-container {\n\theight: 40px;\n\tline-height: 40px;\n\tdisplay: none;\n}\n\n.playback-bar .timer-container.left-side {\n\tfloat: left;\n\tdisplay: block;\n}\n\n.playback-bar .timer-container.right-side {\n\tfloat: right;\n\tdisplay: block;\n}\n\n.progress-indicator {\n\tposition: relative;\n}\n\n.progress-indicator canvas {\n\tposition: absolute;\n\tleft: 0px;\n\ttop: 0px;\n\tpointer-events: none;\n\topacity: 0.5;\n}\n\n.playback-bar:hover .progress-indicator canvas {\n\topacity: 1;\n}\n\n.progress-indicator .progress-indicator-container {\n\tposition: absolute;\n\tleft: 0px;\n\ttop: 0px;\n\twidth: 100%;\n\theight: 100%;\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.progress-indicator-container .progress-indicator-content {\n\theight: 10px;\n\tbackground-color: var(--highlight-bg-color-hover);\n\topacity: 0.8;\n\tpointer-events: none;\n}\n\n.playback-bar:hover .progress-indicator-container .progress-indicator-content {\n\tbackground-color: var(--highlight-bg-color-hover);\n}\n\n.progress-indicator-remaining {\n\tdisplay: block;\n\twidth: 100%;\n\tbackground-color: rgb(139, 139, 139);\n\theight: 10px;\n\tposition: absolute;\n\tz-index: -1;\n\topacity: 0.4;\n}\n\n.progress-indicator-handler {\n\tdisplay: block;\n\twidth: var(--progress-indicator-handler-size);\n\theight: var(--progress-indicator-handler-size);\n\tmargin-left: -10px;\n\tbackground-color: var(--highlight-bg-color-hover);\n\tborder-radius: 10px;\n\tz-index: 1;\n}\n\n.frame-thumbnail {\n\tbackground-color: var(--secondary-bg-color-hover);\n\tmin-width: 100px;\n\tmin-height: 100px;\n\tbox-shadow: 0px 0px 5px 0px var(--main-bg-color);\n\tz-index: 10000;\n\tpointer-events: none;\n}\n\n.frame-thumbnail .thumbnail-image {\n\tpointer-events: none;\n}\n\n.timer-container .progress-indicator-timer {\n\tposition: static;\n\theight: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n\n@media (max-width: 500px) {\n\t.frame-thumbnail .thumbnail-image {\n\t\twidth: 130px;\n\t\tpointer-events: none;\n\t}\n}\n\n@media (max-width: 750px) {\n\t.frame-thumbnail .thumbnail-image {\n\t\twidth: 230px;\n\t\tpointer-events: none;\n\t}\n}\n\n@media (min-width: 750px) {\n\t.frame-thumbnail .thumbnail-image {\n\t\twidth: 330px;\n\t\tpointer-events: none;\n\t}\n}\n\n.frame-thumbnail .thumbnail-time {\n\tpointer-events: none;\n\tfont-size: 12px;\n\tline-height: 12px;\n\tdisplay: block;\n\theight: 12px;\n\tcolor: var(--main-fg-color);\n\ttext-align: center;\n\tmargin: 0;\n\tpadding: 1;\n}\n\n@container player-container (max-width: 700px) {\n\t.playback-bar {\n\t\tmin-height: var(--playback-bar-height-sm);\n\t}\n}\n\n@container playback-bar (max-width: 700px) {\n\n\t.playback-bar .button-plugins button i {\n\t\twidth: var(--button-icon-size-sm);\n\t}\n\n\t.playback-bar .button-plugins {\n\t\theight: var(--button-fixed-height-sm);\n\t}\n\n\t.playback-bar .button-plugins .button-plugin-container button {\n\t\theight: var(--button-fixed-height-sm);\n\t}\n\n\t.playback-bar .button-plugins .button-plugin-container button.fixed-width {\n\t\twidth: var(--button-fixed-width-sm);\n\t}\n\n\t.playback-bar .button-plugins .button-plugin-container div.non-interactive {\n\t\theight: var(--button-fixed-height-sm);\n\t}\n\n\t.playback-bar .button-plugins .button-plugin-container div.non-interactive.fixed-width {\n\t\twidth: var(--button-fixed-width-sm);\n\t}\n\n\t.playback-bar .button-plugins div.non-interactive i {\n\t\twidth: var(--button-icon-size-sm);\n\t}\n\n\t.playback-bar .button-plugins div.no-icon span {\n\t\tline-height: var(--button-fixed-height-sm);\n\t}\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
